import { Link } from "react-router-dom";
import logo1 from "../Images/logo1.png";

const Footer = () => {
  return (
    <>
      <footer className="py-8 bg-slate-700 md:p-6 lg:p-6 " data-aos="fade-up">
        <div className="mx-auto max-w-screen-xl text-center">
          <div className="flex justify-center items-center text-2xl font-semibold text-gray-900">
            <Link to="/main">
              <img src={logo1} alt="Logo" className="h-20" />
            </Link>
          </div>
          <ul className="flex flex-wrap justify-center items-center my-6 text-gray-900">
            <li className="mr-4">
              <Link to="/main" className="text-white">
                Home
              </Link>
            </li>
            <li className="mr-4">
              <Link to="/features" className="text-white">
                Features
              </Link>
            </li>
            <li className="mr-4">
              <Link to="/about-us" className="text-white">
                About Us
              </Link>
            </li>
            <li className="mr-4">
              <Link to="/contact" className="text-white">
                Feedback
              </Link>
            </li>
            <li className="mr-4">
              <Link to="/signin" className="text-white">
                Join Now
              </Link>
            </li>
          </ul>
        </div>
      </footer>
      <div
        className="bg-slate-800 py-6 text-center text-white text-lg font-normal"
        data-aos="fade-up"
      >
        <p className="text-white">
          © {new Date().getFullYear()}{" "}
          <a
            href="#hero-section"
            className="text-[#f0f0f0] hover:opacity-80 font-semibold transition-opacity "
          >
            Interview Detection
          </a>
          <span className="hidden md:inline"> All rights Reserved</span>
        </p>
      </div>
    </>
  );
};

export default Footer;
